export default __webpack_public_path__ + "static/media/Celta_de_Vigo.7eccba61.ico";